import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1Mct1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1fCOGD4ASezqahKpQv4l3LMX805raTmC_/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1luT8by5J3VoB6ViExHfRVUefcnsZcsZs/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1jqs9sswRVs7wxAyC4zi-LoNONlQP3_Dl/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">MCT Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1Mct1;
